import {
  CustomizationSectionType,
  CustomizationSourceType,
} from "@/components/subscription/customize/hooks/useSections";
import type { RouteTarget } from "@/routing/routeTarget";

type ShowCustomizeSectionsType = CustomizationSectionType[];

/**
 * @property {ShowCustomizeSectionsType}  showCustomizeSections  - An array of customize sections to display
 * @property {ReplaceRefreshRotatesSectionType}  showRRRTab - Which tab to display under list - rotate - replace
 * @property {string}  source - Source of the object, used for CTA tracking
 */

export type CustomizeHrefInputType = {
  showCustomizeSections?: ShowCustomizeSectionsType;
  showRRRTab?: ReplaceRefreshRotatesSectionType;
  source: CustomizationSourceType;
  recommendOnDemandRefreshes?: string;
  recommendReplace?: string;
  purchaseInitiatorPath?: string;
  menu?: string; //Used only by ResidentialProxyBanner.
  planId?: string;
  customPathname?: string;
};

type ReplaceRefreshRotatesSectionType =
  | "autorefresh"
  | "replaceAll"
  | "replace";

export const DEFAULT_CUSTOMIZE_PATHNAME = "/subscription/customize";
export const SHOW_REPLACE_REFRESH_ROTATE_QUERY_PARAM_KEY = "show_rrr_tab";
export const DEFAULT_CHECKOUT_PATHNAME = "/subscription/customize/checkout";
export const DEFAULT_CHOOSE_PLAN_PATHNAME = "/subscription/choose-plan";

type CheckoutHrefInputType = {
  source?: string;
  renew?: boolean;
  customizeParams?: string;
  term?: "monthly" | "yearly";
};

export function formCheckoutPageHref({
  source,
  renew,
  term,
  customizeParams,
}: CheckoutHrefInputType): RouteTarget {
  return {
    to: DEFAULT_CHECKOUT_PATHNAME,
    search: {
      customizeParams,
      source,
      renew: renew?.toString(),
      term,
    },
  };
}
